import React from "react";
import {
  FaPhoneAlt,
  FaWhatsapp,
  FaStar,
  FaMapMarkerAlt,
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";

import "../styles/Autos.css";

export default function AutoCard({ driver }) {

  // ✅ Hooks must be called first
  const navigate = useNavigate();

  // ✅ Safe to return after hooks
  if (!driver) return null;

  const {
    driverName,
    autoNumber,
    serviceArea,
    mobile,
    photo,
    available,
    rating,
  } = driver;

  function handleBookRide() {
    navigate("/book-auto", {
      state: {
        driver,
      },
    });
  }

  return (
    <div className="auto-card">

      <div className="auto-top">

        <img
          src={
            photo ||
            "https://via.placeholder.com/100?text=Driver"
          }
          alt={driverName}
          className="auto-photo"
        />

        <div className="auto-details">

          <h3>{driverName}</h3>

          <p className="auto-number">
            🚖 {autoNumber}
          </p>

          <p className="auto-area">
            <FaMapMarkerAlt /> {serviceArea}
          </p>

          <div className="auto-rating">
            <FaStar color="#f4b400" />

            <span>
              {(rating || 5).toFixed(1)}
            </span>
          </div>

        </div>

      </div>

      <div
        className={
          available
            ? "status available"
            : "status busy"
        }
      >
        {available ? "🟢 Available" : "🔴 Busy"}
      </div>

      <div className="auto-actions">

        <a
          href={`tel:${mobile}`}
          className="call-btn"
        >
          <FaPhoneAlt />
          <span>Call</span>
        </a>

        <a
          href={`https://wa.me/91${mobile}`}
          target="_blank"
          rel="noreferrer"
          className="wa-btn"
        >
          <FaWhatsapp />
          <span>WhatsApp</span>
        </a>

      </div>

      <button
        className="book-btn"
        disabled={!available}
        onClick={handleBookRide}
      >
        {available
          ? "🚖 Book Ride"
          : "🔴 Currently Busy"}
      </button>

    </div>
  );
}